









































import { reactive, computed } from '@vue/composition-api'
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { defineComponent, ref, useRouter } from '@nuxtjs/composition-api'
import { debounce } from 'throttle-debounce'
import InputText from '@/components/Inputs/InputText.vue'
import InputSelect from '@/components/Inputs/InputSelect.vue'

@Component
class BlockVacancyFilters extends Vue {
  @Prop() readonly inputSelectData: Object = {}
  @Prop() readonly inputRegionData: Object = {}
  @Prop() readonly inputTextData: Object = {}
  @Prop() readonly listSpecialties: Array = []
  @Prop() readonly listRegions: Array = []
  @Prop() readonly noResultTextSelect: String = ''
  @Prop() readonly initialFilters: {
    search: string
    region: string
    speciality: string
  } = {
    search: '',
    region: '',
    speciality: '',
  }

  static options: any
}

export default defineComponent({
  name: 'BlockVacancyFilters',
  components: { InputText, InputSelect },
  props: BlockVacancyFilters.options.props,
  setup(props, ctx) {
    const router = useRouter()
    const buttonClearText = ref('Сбросить все фильтры')
    const filters = reactive({
      search: props.initialFilters.search,
      region: props.initialFilters.region,
      speciality: props.initialFilters.speciality,
    })

    const show = computed(
      () => filters.search || filters.region || filters.speciality
    )
    const clearFilters = () => {
      router.push({ query: {} })
      filters.search = ''
      filters.region = ''
      filters.speciality = ''
    }
    const tooltip = reactive({
      icon: 'icon/search',
    })
    const changeSearchDebounce = debounce(500, (value: any) => {
      filters.search = value
      router.push({ query: { ...filters } })
      ctx.emit('update-search', value)
    })
    const changeRegion = (value: any) => {
      filters.region = value
      router.push({ query: { ...filters } })
      ctx.emit('update-region', value)
    }
    const changeSpeciality = (value: any) => {
      filters.speciality = value
      router.push({ query: { ...filters } })
      ctx.emit('update-speciality', value)
    }
    return {
      filters,
      changeSpeciality,
      changeRegion,
      tooltip,
      changeSearchDebounce,
      clearFilters,
      buttonClearText,
      show,
    }
  },
})
